import moment from "moment";
export default {
  components: {
    LaborForm: () => import("@/forms/LaborForm"),
    BonoForm: () => import("@/forms/BonoForm"),
    CajaAhorroForm: () => import("@/forms/CajaAhorroForm"),
    PrestamoForm: () => import("@/forms/PrestamoForm"),
    AsistenciasForm: () => import("@/forms/AsistenciasForm"),
  },
  data() {
    return {
      moment,
      docs: [
        {
          name: "Prestaciones",
          cancelTitle: "la prestacion",
          singular: "Prestación",
          view: "VerPrestacion",
          schema: "prestaciones",
        },
        {
          name: "Asistencias",
          cancelTitle: "la asistencia",
          singular: "Asistencia",
          view: "VerAsistencia",
          schema: "asistencias",
        },
        {
          name: "Bonos",
          cancelTitle: "el bono",
          singular: "Bono",
          view: "VerBono",
          schema: "bonos",
        },
        {
          name: "Bonos aplicados",
          cancelTitle: "el bono aplicado",
          singular: "Bono aplicado",
          view: "VerBonoAplicado",
          schema: "bonos_aplicados",
        },
        {
          name: "Cajas de Ahorro",
          cancelTitle: "la caja de ahorro",
          singular: "Caja de ahorro",
          view: "VerCajaAhorro",
          schema: "caja_de_ahorro",
        },
        {
          name: "Cajas de Ahorro aplicadas",
          cancelTitle: "la caja de ahorro aplicada",
          singular: "Caja de ahorro aplicada",
          view: "VerCajaAhorroAplicado",
          schema: "caja_de_ahorro_aplicadas",
        },
        {
          name: "Cálculos Administrativos",
          cancelTitle: "el calculo administrativo",
          singular: "Calculo administrativo",
          view: "VerCalculoAdministrativo",
          schema: "calculos_administrativos",
        },
        {
          name: "Devoluciones de empaque",
          cancelTitle: "la devolución de empaque",
          singular: "Devolución de empaque",
          view: "VerDevolucionEmpaque",
          schema: "devoluciones_empaques",
        },
        {
          name: "Entradas",
          cancelTitle: "la entrada",
          singular: "Entrada",
          view: "VerEntrada",
          schema: "entradas",
        },
        {
          name: "Entregas",
          cancelTitle: "la entrega",
          singular: "Entrega",
          view: "VerEntrega",
          schema: "entregas",
        },
        {
          name: "Gastos",
          cancelTitle: "el gasto",
          singular: "Gasto",
          view: "VerGasto",
          schema: "gastos",
        },
        {
          name: "Jornadas",
          cancelTitle: "la jornada",
          singular: "Jornada",
          view: "VerJornada",
          schema: "jornadas",
        },
        {
          name: "Labores",
          cancelTitle: "la labor",
          singular: "Labor",
          view: "VerLabor",
          schema: "labores",
        },
        {
          name: "Ordenes de compra",
          cancelTitle: "la orden de compra",
          view: "VerOrdenCompra",
          singular: "Orden de compra",
          schema: "ordenes_compra",
        },
        {
          name: "Préstamos",
          cancelTitle: "el préstamo",
          singular: "Préstamo",
          view: "VerPrestamo",
          schema: "prestamos",
        },
        {
          name: "Préstamos aplicados",
          cancelTitle: "el préstamo aplicado",
          singular: "Préstamo aplicado",
          view: "VerPrestamoAplicado",
          schema: "prestamos_aplicados",
        },
        {
          name: "Producciones",
          cancelTitle: "la produccion",
          singular: "Producción",
          view: "VerProduccion",
          schema: "producciones",
        },
        {
          name: "Requisiciones",
          cancelTitle: "la requisicion",
          singular: "Requisición",
          view: "VerRequisicion",
          schema: "requisiciones",
        },
        {
          name: "Salidas",
          cancelTitle: "la salida",
          singular: "Salida",
          view: "VerSalida",
          schema: "salidas",
        },
        {
          name: "Solicitudes de empaque",
          cancelTitle: "la solicitud de empaque",
          singular: "Solicitud de empaque",
          view: "VerSolicitudEmpaque",
          schema: "solicitudes_empaques",
        },
        {
          name: "Traspasos",
          cancelTitle: "el traspaso",
          singular: "Traspaso",
          view: "VerTraspaso",
          schema: "traspasos",
        },
      ],

      tiposCosto: [
        { value: "cosecha", label: "Cosecha" },
        { value: "no_cosecha", label: "No cosecha" },
      ],
      error: "",
      warningModal: false,
      isLoadingPage: false,
      fetching: false,
      actividades: [],
      ubicaciones: [],
      ubicacionesAll: [],
      actividadesAll: [],
      handledSubmit: () => {},
      setData: () => {},
    };
  },
  computed: {
    trabajadoresAll() {
      return this.trabajador ?? [];
    },
    trabajadores() {
      return (
        this.trabajador?.map((trabajador) => {
          return { value: trabajador.id, label: trabajador.payload.nombre };
        }) ?? []
      );
    },
    formData() {
      const data = this.itemModal?.item ?? {};
      console.log(data);
      switch (this.row.schema) {
        case "labores": {
          const ubicaciones = data?.ubicaciones?.map((m) => {
            const ubi = this.ubicacionesAll.find((f) => f.id === m);
            return {
              value: m,
              label: ubi.payload.nombre,
            };
          });
          const trabajador = this.trabajadoresAll.find(
            (f) => f.id === data.trabajador_id
          );
          const actividad = this.actividadesAll.find(
            (f) => f.id === data.actividad_id
          );
          return {
            date: data.fechahora
              ? moment(data.fechahora, "YYYY-MM-DD HH:mm:ss").format(
                  "YYYY-MM-DD"
                )
              : "",
            trabajador: trabajador
              ? {
                  value: trabajador.id,
                  label: trabajador.payload.nombre,
                }
              : null,
            actividad: actividad
              ? {
                  value: actividad.id,
                  label: actividad.payload.nombre,
                }
              : null,
            cantidad: data?.cantidad ?? "",
            cantidadCosto: data?.cantidad_costo ?? "",
            comentarios: data?.comentarios ?? "",
            ubicaciones: ubicaciones ?? [],
            medias: data?.anexos ?? [],
            tiempo_extra: data?.tiempo_extra ?? false,
          };
        }
        case "bonos": {
          const ubicaciones = data?.ubicaciones?.map((m) => {
            const ubi = this.ubicacionesAll.find((f) => f.id === m);
            return {
              value: m,
              label: ubi.payload.nombre,
            };
          });
          const trabajador = this.trabajadoresAll.find(
            (f) => f.id === data.trabajador_id
          );
          return {
            date: data.fechahora
              ? moment(data.fechahora, "YYYY-MM-DD HH:mm:ss").format(
                  "YYYY-MM-DD"
                )
              : "",
            trabajador: trabajador
              ? {
                  value: trabajador.id,
                  label: trabajador.payload.nombre,
                }
              : null,
            ubicaciones: ubicaciones ?? [],

            fechaInicial: data?.fecha_inicial
              ? moment(data?.fecha_inicial, "YYYY-MM-DD HH:mm:ss").format(
                  "YYYY-MM-DD"
                )
              : null,
            fechaFinal: data?.fecha_final
              ? moment(data?.fecha_final, "YYYY-MM-DD HH:mm:ss").format(
                  "YYYY-MM-DD"
                )
              : null,
            concepto: data?.concepto ?? "",
            monto: data?.monto ?? null,
            tipo_costo: data?.tipo_costo
              ? this.tiposCosto.find((f) => f.value == data?.tipo_costo)
              : null,

            comentarios: data?.comentarios ?? "",
            medias: data?.anexos ?? [],
          };
        }
        case "caja_de_ahorro": {
          const trabajador = this.trabajadoresAll.find(
            (f) => f.id === data.trabajador_id
          );
          return {
            date: data.fechahora
              ? moment(data.fechahora, "YYYY-MM-DD HH:mm:ss").format(
                  "YYYY-MM-DD"
                )
              : "",
            trabajador: trabajador
              ? {
                  value: trabajador.id,
                  label: trabajador.payload.nombre,
                }
              : null,
            monto: data?.monto ?? null,
            fechaInicial: data?.fecha_inicial
              ? moment(data?.fecha_inicial, "YYYY-MM-DD HH:mm:ss").format(
                  "YYYY-MM-DD"
                )
              : null,
            fechaFinal: data?.fecha_final
              ? moment(data?.fecha_final, "YYYY-MM-DD HH:mm:ss").format(
                  "YYYY-MM-DD"
                )
              : null,
            comentarios: data?.comentarios ?? "",
            medias: data?.anexos ?? [],
          };
        }
        case "prestamos": {
          const trabajador = this.trabajadoresAll.find(
            (f) => f.id === data.trabajador_id
          );
          return {
            date: data.fechahora
              ? moment(data.fechahora, "YYYY-MM-DD HH:mm:ss").format(
                  "YYYY-MM-DD"
                )
              : "",
            trabajador: trabajador
              ? {
                  value: trabajador.id,
                  label: trabajador.payload.nombre,
                }
              : null,
            fecha_pago: data?.fecha_pago
              ? moment(data?.fecha_pago, "YYYY-MM-DD HH:mm:ss").format(
                  "YYYY-MM-DD"
                )
              : null,
            semanas: data?.semanas ?? null,
            fecha_inicial: data?.fecha_inicial
              ? moment(data?.fecha_inicial, "YYYY-MM-DD HH:mm:ss").format(
                  "YYYY-MM-DD"
                )
              : null,
            monto: data?.monto ?? null,
            comentarios: data?.comentarios ?? "",
            medias: data?.anexos ?? [],
          };
        }
        default: {
          return {};
        }
      }
    },
    fields() {
      if (!this.nomina) {
        const addColumns = () => {
          switch (this.row.schema) {
            case "asistencias": {
              return [
                { key: "trabajador_id", label: "Trabajador", _style: "" },
                { key: "evento", label: "Evento", _style: "width: 90px" },
              ];
            }
            case "bonos_aplicados": {
              return [
                { key: "concepto", label: "Concepto", _style: "" },
                { key: "monto", label: "Monto", _style: "width: 90px" },
              ];
            }
            case "caja_de_ahorro_aplicadas": {
              return [{ key: "monto", label: "Monto", _style: "width: 90px" }];
            }
            case "prestamos_aplicados": {
              return [{ key: "monto", label: "Monto", _style: "width: 90px" }];
            }
            case "prestaciones": {
              return [
                { key: "actividad_id", label: "Actividad", _style: "" },
                {
                  key: "cantidad_costo",
                  label: "Cantidad Costo",
                  _style: "width: 135px",
                },
                {
                  key: "costo_unitario",
                  label: "Costo Unitario",
                  _style: "width: 135px",
                },
                { key: "total", label: "Total", _style: "width: 70px" },
              ];
            }
            default: {
              return [
                // { key: "data", label: "data", _style: "" },
              ];
            }
          }
        };
        return [
          { key: "folio", label: "Folio", _style: "width: 70px" },
          { key: "ubicacion_raiz_id", label: "Ubicación Raíz", _style: "" },
          ...addColumns(),
          {
            key: "ver",
            label: "",
            _style: "width: 40px",
            sorter: false,
            filter: false,
          },
        ];
      }
      const addColumns = () => {
        switch (this.row.schema) {
          case "labores":
          case "prestaciones": {
            return [
              { key: this.row.schema==='prestaciones'?"fechahora":'fechahora_', label: "Fecha", _style: "" },
              { key: "actividad_id", label: "Actividad", _style: "" },
              { key: "tipo", label: "Tipo", _style: "width: 90px" },
              {
                key: "cantidad",
                label: "Horas/Cantidad",
                _style: "width: 90px",
              },
              {
                key: "tiempo_extra",
                label: "Horas Extras",
                _style: "width: 90px",
              },
              {
                key: "costo_unitario",
                label: "Costo Unitario",
                _style: "width: 90px",
              },
              { key: "monto_", label: "Monto", _style: "width: 90px" },
              { key: "author", label: "Usuario", _style: "" },
              { key: "created_at", label: "Creación", _style: "" },
            ];
          }
          case "bonos": {
            return [
              { key: "fechahora", label: "Fecha", _style: "" },
              { key: "fecha_inicial", label: "Fecha inicial", _style: "" },
              { key: "fecha_final", label: "Fecha final", _style: "" },
              { key: "concepto", label: "Concepto", _style: "" },
              { key: "monto", label: "Monto", _style: "width: 90px" },
              { key: "author", label: "Usuario", _style: "" },
              { key: "created_at", label: "Creación", _style: "" },
            ];
          }
          case "bonos_aplicados": {
            return [
              { key: "fechahora", label: "Fecha", _style: "" },
              { key: "concepto", label: "Concepto", _style: "" },
              { key: "monto", label: "Monto", _style: "width: 90px" },
              { key: "author", label: "Usuario", _style: "" },
              { key: "created_at", label: "Creación", _style: "" },
            ];
          }
          case "caja_de_ahorro": {
            return [
              { key: "fechahora", label: "Fecha", _style: "" },
              { key: "fecha_inicial", label: "Fecha inicial", _style: "" },
              { key: "fecha_final", label: "Fecha final", _style: "" },
              { key: "monto", label: "Monto", _style: "width: 90px" },
              { key: "author", label: "Usuario", _style: "" },
              { key: "created_at", label: "Creación", _style: "" },
            ];
          }
          case "caja_de_ahorro_aplicadas": {
            return [
              { key: "fechahora", label: "Fecha", _style: "" },
              { key: "concepto", label: "Concepto", _style: "" },
              { key: "monto", label: "Monto", _style: "width: 90px" },
              { key: "author", label: "Usuario", _style: "" },
              { key: "created_at", label: "Creación", _style: "" },
            ];
          }
          case "prestamos": {
            return [
              { key: "fechahora", label: "Fecha", _style: "" },
              { key: "fecha_inicial", label: "Fecha Inicial", _style: "" },
              { key: "semanas", label: "Semanas", _style: "width: 70px" },
              { key: "monto", label: "Monto", _style: "width: 90px" },
              { key: "author", label: "Usuario", _style: "" },
              { key: "created_at", label: "Creación", _style: "" },
            ];
          }
          case "prestamos_aplicados": {
            return [
              { key: "fechahora", label: "Fecha", _style: "" },
              { key: "monto", label: "Monto", _style: "width: 90px" },
              { key: "author", label: "Usuario", _style: "" },
              { key: "created_at", label: "Creación", _style: "" },
            ];
          }
          case "jornadas": {
            return [
              { key: "fechahora", label: "Fecha", _style: "" },
              { key: "horas_normales", label: "Horas Normales", _style: "" },
              { key: "horas_extras", label: "Horas Extras", _style: "" },
              { key: "author", label: "Usuario", _style: "" },
              { key: "created_at", label: "Creación", _style: "" },
            ];
          }
          case "asistencias": {
            return [
              { key: "fechahora", label: "Fecha", _style: "" },
              { key: "hora", label: "Hora" },
              { key: "evento", label: "Evento" },
              { key: "author", label: "Usuario" },
              { key: "created_at", label: "Creación" },
            ];
          }
          default: {
            return [];
          }
        }
      };
      return [
        { key: "folio", label: "Folio", _style: "width: 70px" },

        ...addColumns(),
        {
          key: "ver",
          label: "",
          _style: "width: 40px",
          sorter: false,
          filter: false,
        },
        ...(this.crud
          ? [
              {
                key: "edit",
                label: "",
                _style: "width: 50px",
                sorter: false,
                filter: false,
              },
              {
                key: "cancel",
                label: "",
                _style: "width: 70px",
                sorter: false,
                filter: false,
              },
            ]
          : []),
      ]
        .filter((ff) => ff.key !== "edit" || this.hasEdit)
        .filter((ff) => ff.key !== "cancel" || this.hasDel);
    },
    ubicacionRaiz() {
      return this.$store.state.rootLocation
        ? this.$store.state.rootLocation.value
        : "";
    },
    ubicacionRaizValue() {
      return this.$store.state.rootLocation
        ? this.$store.state.rootLocation.value
        : "";
    },
  },
  methods: {
    async addItem() {
      this.error = "";
      this.warningModal = false;
      switch (this.row.schema) {
        case "prestamos":
        case "caja_de_ahorro":
        case "bonos":
        case "labores": {
          this.fetching = true;
          this.isLoading = true;
          await new Promise((res) => {
            const iter = setInterval(() => {
              if (!this.fetching) {
                this.error = "";
                clearInterval(iter);
                res();
              }
            }, 1000);
          });
          this.isLoading = false;

          if (this.error) {
            this.successModal = false;
            return;
          }
          break;
        }
        default: {
          break;
        }
      }

      const form = this.handledSubmit();
      console.log(form);
      if (form.skip) {
        return;
      }
      if (form.error && form.warningModal) {
        this.error = form.error;
        this.warningModal = form.warningModal;
        return;
      }
      if (this.itemModal?.index > -1) {
        form.folio = this.itemModal?.item?.folio;
        form.payload.encabezado.nanoid = this.itemModal?.item?.nanoid;
      }
      this.isLoading = true;

      this.$store
        .dispatch(
          this.itemModal?.index > -1
            ? "customDocumentoRemplazarHTTP"
            : "customDocumentoAddHTTP",
          form
        )
        .then((res) => {
          console.log(this.itemModal);

          console.log(res);
          const body = {
            schema: this.row.schema,
            "with-storage": ["*"],
            filter: {
              wherein: [
                {
                  field: `doc_${this.row.schema}.folio`,
                  value: [res.data.folio],
                },
                {
                  field: `doc_${this.row.schema}.payload->encabezado->ubicacion_raiz_id`,
                  value: [res.data.payload.encabezado.ubicacion_raiz_id],
                },
              ],
            },
          };
          console.log(body);
          return this.$store
            .dispatch("customDocumentoHTTP", body)
            .then((res) => {
              if (res.data.length > 0) {
                const { folio, payload, ...rest } = res.data[0];
                payload;
                const item = {
                  folio,
                  ...rest,
                  ...(res.data.find((f) => f.folio === folio)?.payload
                    ?.encabezado ?? {}),
                };
                const index =
                  this.itemModal.index > -1 ? this.itemModal.index : 0;
                const step = this.itemModal.index > -1 ? 1 : 0;
                this.items.splice(index, step, item);
                setTimeout(() => {
                  this.$emit("getData", false);
                }, 2000);
              }
            });
        })
        .catch((rej) => {
          console.log(rej);
          this.error = rej.message;
          this.warningModal = true;
          this.isLoading = false;
          return;
        })
        .finally(() => {
          this.isLoading = false;
          if (!this.warningModal) {
            this.successModal = true;
            this.formModal = false;
          }
        });
    },
    async pushMedia(files) {
      const arr = [];

      for (const v of files.map(async (m) => {
        // eslint-disable-next-line no-extra-boolean-cast
        if (!!m.media) {
          return Promise.resolve({ data: m, status: "success" });
        }
        const formData = new FormData();
        formData.append("media", m);
        const promise = await this.$store.dispatch("customImageHTTP", formData);

        return promise;
      })) {
        const media = await v;

        if (media.status === "success") {
          arr.push(media.data);
        }
      }
      return arr;
      /*
        const formData = new FormData()
        formData.append('media', format.dataURLtoFile(this.fileList[0].thumbUrl))
        this.$store.dispatch('MEDIA_CARGAR', formData)
      */
    },
    relacionesByNomina(relaciones) {
      return Object.values(relaciones).reduce((v, c) => {
        const items = c;
        if (Array.isArray(items)) {
          v.push(...items);
        }

        return v;
      }, []);
    },
    nomina2Docs(documentosR) {
      return Object.entries(documentosR).reduce((v, c) => {
        const [key, value] = c;
        if (Array.isArray(value)) {
          v.push(...value.map((m) => ({ schema: key, ...m })));
        }
        return v;
      }, []);
    },
    documentosRelacionados(documentosR) {
      return this.docs.reduce((v, c) => {
        const documentos = documentosR.filter((ff) => ff.schema === c.schema);
        if (documentos.length > 0) {
          v.push({ ...c, children: documentos });
        }
        return v;
      }, []);
    },
    allDocumentosRelacionados(documentosR) {
      return this.docs.reduce((v, c) => {
        const documentos = documentosR.filter((ff) => ff.schema === c.schema);

        v.push({ ...c, children: documentos });

        return v;
      }, []);
    },
  },
  created() {
    if (!this.crud) {
      return;
    }

    const ubi = [
      // this.$store.dispatch("customHTTP", {
      //   schema: "trabajadores",
      //   filter: {
      //     where: [
      //       {
      //         field: "payload->ubicaciones",
      //         operator: "regexp",
      //         value: `[[:<:]]${this.ubicacionRaizValue}[[:>:]]`,
      //       },
      //       {
      //         field: "payload->suspendido",
      //         operator: "!=",
      //         value: true,
      //       },
      //     ],
      //   },
      // }),
      this.$store.dispatch("customHTTP", {
        schema: "actividades",
        filter: {
          where: [
            {
              field: "payload->unidad",
              value: "",
              operator: "!=",
            },
          ],
        },
      }),
      this.$store.dispatch("customHTTP", {
        schema: "ubicaciones",
        filter: {
          where: [
            {
              field: "payload->raiz_id",
              value: this.ubicacionRaizValue,
              operator: "=",
            },
            {
              field: "payload->suspendido",
              value: false,
              operator: "="
            }
          ],
        },
        order:[{
          field: 'payload->nombre',
          direction: 'asc'
        }]
      }),
    ];
    Promise.all(ubi)
      .then(([actividades, ubicaciones]) => {
        this.actividades = actividades.data.map((actividad) => {
          return { value: actividad.id, label: actividad.payload.nombre };
        });

        this.ubicaciones = ubicaciones.data.map((ubicacion) => {
          return { value: ubicacion.id, label: ubicacion.payload.nombre };
        });

        this.ubicacionesAll = ubicaciones.data;

        this.actividadesAll = actividades.data;
      })
      .finally(() => (this.isLoadingPage = false));
  },
};
